import { effect, inject, Injectable, signal } from '@angular/core';
import { Pengeinstitut } from './pengeinstitut.model';
import { PiSearchParams } from './pi-search/pi-search-params.model';
import { PengeinstitutterIndstillingerService } from './pi-indstilling/pengeinstitutindstillinger.service';
import { PengeinstitutHistorikService } from './pi-historik/pi-historik.service';
import { PengeinstitutDatasource } from '@features/pengeinstitutter/pengeinstitut.datasource';

@Injectable({
  providedIn: 'root',
})
export class PengeinstitutterService {
  datasource = inject(PengeinstitutDatasource);

  constructor() {
    effect(() => {
      if (this.datasource.data.status() == 'resolved') {
        const data = this.datasource.data.value();
        if (data && data.totalRowCount > 0) {
          this.activeTab.set('result');
        }
      }
    });
  }

  piIndstillingerService = inject(PengeinstitutterIndstillingerService);

  piHistorikService = inject(PengeinstitutHistorikService);

  selectedPi = signal<Pengeinstitut | undefined>(undefined);
  activeTab = signal('search');

  async searchPi(searchParams: PiSearchParams): Promise<void> {
    this.selectedPi.set(undefined);
    this.datasource.searchParams.set(searchParams);
  }

  async selectPiResultRow(pengeinstitut: Pengeinstitut) {
    await this.selectPengeinstitut(pengeinstitut);

    if (pengeinstitut) {
      this.activeTab.set('detail');
    }
  }

  async selectPengeinstitut(pengeinstitut: Pengeinstitut) {
    const pi = await this.datasource.getById(pengeinstitut.id!);
    this.selectedPi.set(pi);
    this.piIndstillingerService.datasource.pengeinstitutId.set(
      pengeinstitut.id
    );
    this.piHistorikService.datasource.pengeinstitutId.set(pengeinstitut.id);
  }
}
